<template>
  <!-- reprocessTransfer Modal -->
  <div
    class="modal fade"
    id="reprocessTransferModal"
    tabindex="-1"
    aria-labelledby="reprocessTransferModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="reprocessTransferModalLabel">
            Reprocess Transfer Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb3-3">
            Are you sure you want to reprocess the selected Transfer?
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            No
          </button>
          <button
            type="button"
            class="btn btn-danger"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="reprocessTransfer"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- resubmitTransfer Modal -->
  <div
    class="modal fade"
    id="resubmitTransferModal"
    tabindex="-1"
    aria-labelledby="resubmitTransferModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="resubmitTransferModalLabel">
            Resubmit Transfer Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb3-3">
            Are you sure you want to resubmit the selected Transfer?
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            No
          </button>
          <button
            type="button"
            class="btn btn-danger"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="resubmitTransfer"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- cancelTransfer Modal -->
  <div
    class="modal fade"
    id="cancelTransferModal"
    tabindex="-1"
    aria-labelledby="cancelTransferModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="cancelTransferModalLabel">
            Cancel Transfer Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb3-3">
            Are you sure you want to cancel the selected Transfer?
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            No
          </button>
          <button
            type="button"
            class="btn btn-danger"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="cancelTransfer"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- resubmitSip Modal -->
  <!-- <div
    class="modal fade"
    id="resubmitSipModal"
    tabindex="-1"
    aria-labelledby="resubmitSipModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="resubmitSipModalLabel">
            Resubmit SIP Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb3-3">
            Are you sure you want to resubmit the selected SIP?
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            No
          </button>
          <button
            type="button"
            class="btn btn-danger"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="resubmitSip"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import { useTransferStore } from "@/stores/content_review/transfer";
import { ref, watch } from "vue";

const transferStore = useTransferStore();
const emit = defineEmits(["listen-refresh-table"]);

const props = defineProps({
  transferId: { type: String },
  // sipId: { type: String }
});
const selectedTransferId:any = ref(props.transferId);
// const selectedSipId: any = ref(props.sipId);

watch(
  () => props.transferId,
  (newTransferId) => (selectedTransferId.value = newTransferId)
);

// watch(
//   () => props.sipId,
//   (newSipId) => (selectedSipId.value = newSipId)
// );

const reprocessTransfer = async () => {
  await transferStore.reprocessTransfer(selectedTransferId.value);
};

const resubmitTransfer = async () => {
  await transferStore.resubmitTransfer(selectedTransferId.value);
};

const cancelTransfer = async () => {
  await transferStore.cancelTransfer(selectedTransferId.value);
}

// const resubmitSip = async () => {
//   await transferStore.resubmitSip(selectedSipId.value);
// };
</script>

<style scoped>
li {
  padding-right: 10px;
  margin: auto;
  display: inline-block;
}
.btn-selected:hover {
  background: #6c757d;
  cursor: default;
}
</style>
